function envVersion() {
	let version = process.env.NODE_ENV;

	switch (version) {
		case 'development':
			// return 'https://测试版环境域名' 本地开发;
			// console.log('development','本地环境')
			return {
				// baseUrl: "https://designapi.wsandos.com/", //测试
				// baseUrl: "http://192.168.1.110:8081", //例子
				baseUrl: 'https://login.cdn-design.com', //正式
			};
			break;
		case 'production':
			// 生产环境(线上环境)
			// console.log('production','生产环境')
			return {
				// baseUrl: "https://designapi.wsandos.com/", //例子
				baseUrl: 'https://login.cdn-design.com', //例子
			};
			break;
		default:
			// return 'https://测试版环境域名';
			// console.log('development','默认本地环境')
			return {
				// baseUrl: "https://login.cdn-design.com", //例子
				baseUrl: 'https://login.cdn-design.com', //例子
			};
	}
}

module.exports = {
	envVersion,
};
